<template>
  <div class="logsContainer">
    <!-- 条件 -->
    <el-row>
      <el-form label-width="68px" ref="form" :model="form">

        <el-col :span="9">
          <el-form-item label="时间" :rules="{required: true, message: '必填项'}" prop="time">
            <el-date-picker
              v-model="form.time"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视讯号">
            <el-input v-model="form.nube"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="设备类型">
            <el-select v-model="form.devtype"
                       placeholder="设备类型" clearable>
              <el-option v-for="(option, index) in devTypes"
                         :key="index"
                         :value="option"
                         :label="option"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="downLoad" type="primary" style="margin-left: 15px"
                     v-if="listOperations.some(func => func.name.includes('download'))">
            下载
          </el-button>
        </el-col>
      </el-form>
    </el-row>
    <!-- 数据列表 -->
    <el-table
      :data="lists"
      ref="multipleTable"
      @selection-change="handleSelectionChange" :row-key="rowKey">
      <el-table-column type="selection" width="55" reserve-selection></el-table-column>
      <el-table-column align="center" prop="devType" label="设备类型" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column align="center" prop="userId" label="视讯号" width="100"></el-table-column>
      <el-table-column align="center" prop="fileName" label="文件名" width="420"></el-table-column>
      <el-table-column align="center" label="存储类型" width="220">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.storageType==1" type="" effect="dark">本地存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==2" type="success" effect="success">腾讯云存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==4" type="danger" effect="warning">阿里云存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==3" type="danger" effect="success">本地、腾讯云存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==5" type="danger" effect="warning">本地、阿里云存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==6" type="danger" effect="success">腾讯云、阿里云存储</el-tag>
          <el-tag v-else-if="scope.row.storageType==7" type="danger" effect="success">本地、腾讯云、阿里云存储</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="200"></el-table-column>
      <el-table-column align="center" prop="fileSize" label="文件大小" width="200">
        <template v-slot="{row}">
          <span v-if="row.fileSize<1024">{{row.fileSize}}B</span>
          <span v-if="row.fileSize>=1024 && row.fileSize<1024*1024">{{parseInt(row.fileSize/1024)}}KB</span>
          <span v-if="row.fileSize>=1024*1024">{{parseFloat(row.fileSize/1024/1024).toFixed(2)}}M</span>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[30,50,70,100]"
      :page-size="pageSize"
      :total="totalElement"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>

  </div>
</template>
<script>
  import {Loading} from 'element-ui'
  import {mapMutations, mapState} from "vuex";

  export default {
    data: vm => ({
      form: {
        startTime: '',
        endTime: '',
        time: '',
        nube: '',
        devtype: ''
      },
      devTypes: [],
      time: ['', ''],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end])
          }
        }]
      },
      lists: [],
      currentPage: 1,
      pageSize: 30,
      totalElement: 0,
      showDataDetail: false,
      currentData: {}, // 当前选中的行
      multipleSelection: []
    }),
    created() {
      this.getListOperations('logs/terminallogs')
      if (!this.currentMenu) {
        return
      }
      this.getDevTypes()
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    },
    methods: {
      ...mapMutations(['getListOperations']),
      cellClick(row, column, event) {
        this.currentData = row;
        // eslint-disable-next-line eqeqeq
        if (column.label == '日志内容') {
          this.showDataDetail = true
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList()
      },
      search() {
        this.currentPage = 1;
        this.$refs.form.validate(valid => {
          if (valid) {
            this.getList()
          } else {
            this.$message.warning('请填写必填项')
          }
        })
      },
      getList() {
        this.$refs.multipleTable.clearSelection();
        this.multipleSelection = [];
        this.lists = [];
        let loading = Loading.service({
          fullscreen: true,
          text: '数据加载中...'
        });
        let devtype = this.form.devtype ? this.form.devtype : null;
        let nube = this.form.nube ? this.form.nube : null;
        let stime = new Date(this.form.time[0]).format('yyyyMMddhhmmss');
        let etime = new Date(this.form.time[1]).format('yyyyMMddhhmmss');
        this.$axios.get(this.logCollectServerUrl + 'log/search/' + devtype + '/' + nube + '/' + stime +
          '/' + etime +
          '/' + this.currentPage + '/' + this.pageSize)
          .then(({data: {code, msg, data}}) => {
            loading.close();
            // eslint-disable-next-line eqeqeq
            if (code != 20000) {
              this.$message.error(msg);
              return
            }
            this.lists = data.fileInfo;
            this.totalElement = data.total
          })
          .catch(err => {
            loading.close();
            console.log(err)
          })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      rowKey(row) {
        return row.fileName
      },
      downLoad() {
        if (this.multipleSelection.length < 1) {
          this.$message.warning('请选择要下载的数据');
          return
        }
        let loading = Loading.service({
          fullscreen: true,
          text: '数据加载中...'
        });
        let arraydata = [];
        this.multipleSelection.forEach(row => {
          let obj = {
            devType: row.devType,
            userId: row.userId,
            fileName: row.fileName,
            storageType: row.storageType
          };
          arraydata.push(obj)
        });
        let data = {
          fileInfo: arraydata
        };
        let url = this.logCollectServerUrl + 'log/getDownloadUrl';
        this.$axios
          .post(url, data)
          .then(({data: {msg, data, code}}) => {
            // eslint-disable-next-line eqeqeq
            if (code == 20000) {
              window.location.href = data
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close()
          })
          .catch(err => {
            loading.close();
            console.log(err)
          })
      },
      getDevTypes() {
        this.$axios.get(this.logCollectServerUrl + 'log/getDevType')
          .then(({data: {code, msg, data}}) => {
            // eslint-disable-next-line eqeqeq
            if (code != 20000) {
              this.$message.error(msg)
              return
            }
            this.devTypes = data
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>
<style scoped>
  .logsContainer >>> .el-form-item {
    width: 90%;
  }

</style>
